export class BufferDurations {

  public id: string;
  public d1: number;
  public d2: number;
  public d3: number;

  static fromDto(bf: any): BufferDurations {
    if (!bf) {
      return null;
    }

    const bufferDurations = new BufferDurations();

    bufferDurations.id = bf.id;
    bufferDurations.d1 = this.secondsToHours(bf.d1);
    bufferDurations.d2 = this.secondsToHours(bf.d2);
    bufferDurations.d3 = this.secondsToHours(bf.d3);

    return bufferDurations;
  }

  static toDto(bf: BufferDurations): any {
    if (!bf) {
      return null;
    }

    return {
      id: bf.id,
      d1: this.hoursToSeconds(bf.d1),
      d2: this.hoursToSeconds(bf.d2),
      d3: this.hoursToSeconds(bf.d3),
    };
  }

  private static secondsToHours(seconds: number): number {
    return seconds / 60 / 60;
  }

  private static hoursToSeconds(hours: number): number {
    return hours * 60 * 60;
  }

  constructor() {
    this.d1 = 0;
    this.d2 = 0;
    this.d3 = 0;
  }

  setDefaultValue() {
    this.d1 = 1;
    this.d2 = 2;
    this.d3 = 4;
  }
}
